const MINUTE_MS = 60 * 1000;

export const GOOGLE_ADS_SIGNUP_CLAIM_LEASE_MS = 30 * 1000;

const RETRY_DELAYS_MS = [
  MINUTE_MS,
  5 * MINUTE_MS,
  30 * MINUTE_MS,
  6 * 60 * MINUTE_MS,
  24 * 60 * MINUTE_MS,
] as const;

export function getGoogleAdsSignupRetryDelayMs(attemptCount: number) {
  const normalizedAttemptCount = Math.max(1, Math.floor(attemptCount));
  const index = Math.min(
    normalizedAttemptCount - 1,
    RETRY_DELAYS_MS.length - 1
  );
  return RETRY_DELAYS_MS[index];
}

export function normalizeGoogleAdsEnhancedConversionEmail(email: string) {
  return email.trim().toLowerCase();
}
